import i18next from 'i18next';
import ProgramLogo from '../../../../../components/Shared/Icons/Program';
import Programs from '../../../../../components/Programs/List';
import DashboardLogo from '../../../../../components/Shared/Icons/DashboardLogo';
import ProgramDashboard from '../../../../../components/ProgramDashboard';

const PROGRAM_ROUTE_LIST_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/programs',
  exact: true,
  additional: {
    component: Programs,
    protected: true,
    title: i18next.t('titles:programs'),
    icon: ProgramLogo,
    // permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const PROGRAM_ROUTE_DASHBOARD_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/programs/:programUuid/:tableName/list',
  exact: true,
  parentRoute: PROGRAM_ROUTE_LIST_DS,
  additional: {
    component: ProgramDashboard,
    protected: true,
    title: i18next.t('titles:programDashboard'),
    icon: DashboardLogo,
  },
};

const PROGRAM_ROUTE_LIST = {
  path: '/:currentAccountUuid/programs',
  exact: true,
  additional: {
    component: Programs,
    protected: true,
    title: i18next.t('titles:programs'),
    icon: ProgramLogo,
    // permission: permissions.ADMIN_PATIENT_IMPORT,
  },
};

const PROGRAM_ROUTE_DASHBOARD = {
  path: '/:currentAccountUuid/patients/:patientUuid/programs/:programUuid/:tableName/list',
  exact: true,
  parentRoute: PROGRAM_ROUTE_LIST,
  additional: {
    component: ProgramDashboard,
    protected: true,
    title: i18next.t('titles:programDashboard'),
    icon: DashboardLogo,
  },
};


export const PROGRAM_ROUTES = {
  // ------- For child accounts ------
  listDS: PROGRAM_ROUTE_LIST_DS,
  dashboardDS: PROGRAM_ROUTE_DASHBOARD_DS,

  // ------- For current accounts ------
  list: PROGRAM_ROUTE_LIST,
  dashboard: PROGRAM_ROUTE_DASHBOARD,

};

